import { NetFetch } from '../Net/NetFetch';
import { UnauthorizedError } from './Error/UnauthorizedError';
import { StatusCodes } from './Status/StatusCodes';
/**
 * Tour
 */
export class Tours {
    /**
     * getList
     */
    static async getList(filter) {
        const result = await NetFetch.postData('/json/tours/list', filter !== null && filter !== void 0 ? filter : {});
        if (result && result.statusCode) {
            switch (result.statusCode) {
                case StatusCodes.OK:
                    return result;
                case StatusCodes.UNAUTHORIZED:
                    throw new UnauthorizedError();
            }
        }
        return null;
    }
    /**
     * getTrackingList
     * @param tourId
     */
    static async getTrackingList(tourId) {
        const result = await NetFetch.postData('/json/tours/tracking/list', {
            tour_id: tourId
        });
        if (result && result.statusCode) {
            switch (result.statusCode) {
                case StatusCodes.OK:
                    return result.tracking;
                case StatusCodes.UNAUTHORIZED:
                    throw new UnauthorizedError();
            }
        }
        return null;
    }
    /**
     * Resolve previous/next tour (same vehicle) for the tracking-edit picker.
     * @param tourId
     */
    static async getTrackingNeighbors(tourId) {
        const result = await NetFetch.postData('/json/tours/tracking/neighbors', {
            tour_id: tourId
        });
        if (result && result.statusCode) {
            switch (result.statusCode) {
                case StatusCodes.OK:
                    return { prev: result.prev, next: result.next };
                case StatusCodes.UNAUTHORIZED:
                    throw new UnauthorizedError();
            }
        }
        return null;
    }
    /**
     * Delete tracking points whose GPS timestamp falls inside [timestampFrom, timestampTo].
     * @param tourId
     * @param timestampFrom inclusive ms epoch
     * @param timestampTo   inclusive ms epoch
     */
    static async deleteTracking(tourId, timestampFrom, timestampTo) {
        var _a, _b;
        const result = await NetFetch.postData('/json/tours/tracking/delete', {
            tour_id: tourId,
            timestamp_from: timestampFrom,
            timestamp_to: timestampTo
        });
        if (result && result.statusCode === StatusCodes.UNAUTHORIZED) {
            throw new UnauthorizedError();
        }
        if (result && result.statusCode === StatusCodes.OK) {
            return (_a = result.deleted) !== null && _a !== void 0 ? _a : 0;
        }
        throw new Error((_b = result === null || result === void 0 ? void 0 : result.msg) !== null && _b !== void 0 ? _b : 'Delete failed');
    }
    /**
     * Transfer tracking points whose timestamp falls in [timestampFrom, timestampTo]
     * from source tour to target tour.
     */
    static async transferTracking(tourIdFrom, tourIdTo, timestampFrom, timestampTo) {
        var _a, _b;
        const result = await NetFetch.postData('/json/tours/tracking/transfer', {
            tour_id_from: tourIdFrom,
            tour_id_to: tourIdTo,
            timestamp_from: timestampFrom,
            timestamp_to: timestampTo
        });
        if (result && result.statusCode === StatusCodes.UNAUTHORIZED) {
            throw new UnauthorizedError();
        }
        if (result && result.statusCode === StatusCodes.OK) {
            return (_a = result.transferred) !== null && _a !== void 0 ? _a : 0;
        }
        throw new Error((_b = result === null || result === void 0 ? void 0 : result.msg) !== null && _b !== void 0 ? _b : 'Transfer failed');
    }
}
